import {FC} from 'react'
import {downloadTemplateUser, uploadMasiveUser} from '../../../../services'
import {ShowSnackBar} from '../../../../../../util/functions'
import {FormMasiveBulk} from '../../../../../../components/UI/Form/MasiveBulk'

const MasiveUploadUser: FC = () => {
  const handleUpload = async (formData: FormData, bulkLoadId: string): Promise<any> => {
    try {
      const response = await uploadMasiveUser(formData, bulkLoadId)
      return response
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }

  return (
    <FormMasiveBulk
      serviceTemplate={downloadTemplateUser}
      handleSendService={handleUpload}
      textData1='Carga masiva de Perfiles:'
      textData='Carga masiva de Usuario:'
      title='Usuario'
    />
  )
}

export {MasiveUploadUser}
